import { render, staticRenderFns } from "./HeroUpgradeGift.vue?vue&type=template&id=28a7bb76&scoped=true"
import script from "./HeroUpgradeGift.vue?vue&type=script&lang=js"
export * from "./HeroUpgradeGift.vue?vue&type=script&lang=js"
import style0 from "./HeroUpgradeGift.vue?vue&type=style&index=0&id=28a7bb76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a7bb76",
  null
  
)

export default component.exports